import { useNavigate } from "react-router-dom";
import { useChat } from "../contexts/ChatContext";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";
import { MessageCircle } from "lucide-react";

export const ChatButton = () => {
  const navigate = useNavigate();
  const { unseenMessages } = useChat();
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return null;

  // FIXED: Properly calculate total unseen messages
  const totalUnseen = Object.values(unseenMessages || {}).reduce((sum, count) => {
    const numCount = typeof count === 'number' ? count : 0;
    return sum + numCount;
  }, 0);

  // Debug logging
  if (process.env.NODE_ENV === 'development') {
    console.log("ChatButton - Unseen messages:", {
      unseenMessages,
      totalUnseen,
      objectValues: Object.values(unseenMessages || {})
    });
  }

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Button
        onClick={() => navigate("/messages")}
        className="relative w-14 h-14 rounded-full bg-igbanwo-mint hover:bg-emerald-600 shadow-lg p-0 transition-transform hover:scale-105"
      >
        <MessageCircle className="w-6 h-6 text-white" />
        {totalUnseen > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-medium border-2 border-white">
            {totalUnseen > 99 ? '99+' : totalUnseen}
          </span>
        )}
      </Button>
    </div>
  );
};